import W from "./content-cards-provider-factory.js";
import r from "../managers/braze-instance.js";
export function getCachedContentCards() {
  if (r.rr()) return W.m().ki(!1);
}
